import { Box } from '@chakra-ui/react';
import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import LogoLoader from 'components/Loader/LogoLoader';
import { StatusMascot } from 'components/Mascot';
import { useFetchWhoIsWorking } from 'hooks/whoIsWorking/useFetchWhoIsWorking';
import { useUserStore } from 'store/useUserStore';

import { initialSearchQuery, useSearchParamStore } from './shared/useSearchParamStore';
import WhoIsWorkingMap from './WhoIsWorkingMap';
import WorkingEmployees from './WorkingEmployees';

const WhoIsWorking: React.FC<unknown> = () => {
  const { t } = useTranslation(['whoIsWorking']);

  const mapRef = useRef(null);
  const [firstRender, setFirstRender] = useState(true);

  const headerHeight = useUserStore(state => state.headerHeight);

  const [activeEmployee, setActiveEmployee] = useState<any>(null);

  const { working, group_ids, updateSearchQuery } = useSearchParamStore();
  const { status, data, isRefetching } = useFetchWhoIsWorking({ working, group_ids }, { enabled: !firstRender });

  /**
   * Resets searchQuery on first render
   */
  useEffect(() => {
    if (firstRender) {
      updateSearchQuery(initialSearchQuery);
      setFirstRender(false);
    }
  }, [updateSearchQuery, firstRender]);

  if (status === 'loading' && isRefetching) return <LogoLoader />;

  if (status === 'error')
    return (
      <StatusMascot
        type="error"
        description={t('whoIsWorking:unableToFetchWorkingUsersData')}
        wrapperProps={{ id: 'who-is-working-mascot' }}
      />
    );

  return (
    <Box position="relative" height={`calc(100vh - ${headerHeight}px)`} minHeight="70vh">
      {status === 'success' && !data?.payload?.length ? (
        <StatusMascot
          type="main"
          description="Have your users clock in or adjust their location settings to see them on the map."
          wrapperProps={{ id: 'who-is-working-mascot' }}
        />
      ) : (
        <WhoIsWorkingMap activeEmployee={activeEmployee} ref={mapRef} />
      )}

      <WorkingEmployees activeEmployee={activeEmployee} setActiveEmployee={setActiveEmployee} mapRef={mapRef} />
    </Box>
  );
};

export default WhoIsWorking;
